import utils from './utils';

const URL = `${BASE_API_URL}/v2/education/student/`;
const ORDERS_API = `${BASE_API_URL}/orders`;
const BILLING_API = `${window.location.href}orders`

export default {
  getCourses: () => utils.get(`${URL}courses/`),
  getCourse: uuid => utils.get(`${URL}courses/${uuid}/`),
  getLessons: student_course => utils.get(`${URL}lessons/`, { student_course }),
  getLesson: uuid => utils.get(`${URL}lessons/${uuid}/`),
  getLessonAdditional: lessonID => utils.get(`${URL}lessons/${lessonID}/additional/`),
  setLessonAdditional: (lessonID, module_class) => utils.post(`${URL}lessons/${lessonID}/additional/`, {module_class}),
  getLessonTab: (lessonUUID, tabId) => utils.get(`${URL}lessons/${lessonUUID}/tabs/${tabId}/`),
  //загружаем контент для страницы Старт и финиш
  getLessonStart: uuid => utils.get(`${URL}courses/${uuid}/start/`),
  getLessonFinish: uuid => utils.get(`${URL}courses/${uuid}/finish/`),
  //update start finish isRead value
  setRead: (template, uuid, data=null) => utils.put(`${URL}courses/${uuid}/${template}/`, data),
  //загружаем контент для страницы HOME
  getLessonsNearest: () => utils.get(`${URL}lessons/nearest/`),
  //апи для загрузки контента Домашнего задания, и его отправки на сервер
  updateStudentHomework: (lessonId, data) => utils.put(`${URL}lessons/${lessonId}/homework/`, data),
  getStudentHomework: lessonId => utils.get(`${URL}lessons/${lessonId}/homework/`),
  // DRILLING: transitional — delete at legacy sunset. Served by the portal itself
  // (cabinet.student.views.courses.student_drills_json), not the v2 education API.
  getLessonDrills: lessonUuid => utils.get(`/student/courses/lessons/${lessonUuid}/drills.json`),
  // DRILLING: every drill this student has, for the dashboard. The student comes from the
  // session, never the URL — naming one would hand a caller someone else's work.
  getAllDrills: () => utils.get(`/student/drills.json`),
  postStudentMSG: (lessonId, message, addressee)=> utils.post(`${URL}lessons/${lessonId}/helpdesk/`, {message, addressee}),
  getAddressee: (lessonId)=> utils.get(`${URL}lessons/${lessonId}/helpdesk/projects/`),
  // api для работы со счетами студента
  getOrdersList: ()=> utils.get(`${ORDERS_API}/my/list.json`),
  getPaymentType: ({id})=> utils.handleGet(`${ORDERS_API}/my/${id}/method.json`),
  getTransitionsList: ()=> utils.get(`${ORDERS_API}/my/transactions.json`),
  changePaymentType: ({id, type})=> utils.post(`${ORDERS_API}/my/${id}/method.json`, {method: type}),
  deleteOrder: ({id})=> utils.delete(`${ORDERS_API}/my/${id}.json`),
  discountOrder: ({id, code})=> utils.put(`${ORDERS_API}/my/${id}/discount.json`, { code, discount: null, discount_type: null }),
  // student support
  submitIssue: ({message, attachment}) => utils.post(`${URL}error_notice/`, {message, attachment}),
}



// WEBPACK FOOTER //
// ./src/api/student.js